import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2, Heading3 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { Element, Link } from 'react-scroll';
import ServiceEventTracking from 'services/service.event-tracking';
import { getPublicPath } from 'utils/paths';
import { FEATURESITEMS } from './Features.constants';
import {
  StyledContainer,
  StyledCta,
  StyledFeature,
  StyledFeatureContent,
  StyledFeatureImage,
  StyledFeatureList,
  StyledHeader,
  StyledStep
} from './Features.styled';

const TEFeatures: React.FC = () => {
  const { t } = useI18n('talent-engine-landing-v3');

  const features = FEATURESITEMS(t);

  return (
    <StyledContainer>
      <StyledHeader>
        <Heading2 editorial>
          {t('talent-engine-landing.features.title')}
        </Heading2>
        <HtmlTrans
          ns="talent-engine-landing-v3"
          i18nKey="talent-engine-landing.features.desc"
        />
      </StyledHeader>
      <StyledFeatureList>
        {features.map((feature, index) => (
          <StyledFeature key={index}>
            <StyledFeatureImage>
              <img src={feature.image} alt="" className="desktop" />
              <img src={feature.imageSm} alt="" className="mobile" />
            </StyledFeatureImage>
            <StyledFeatureContent>
              <Heading3 editorial alignLeft>
                {feature.title}
              </Heading3>
              <HtmlTrans ns="talent-engine-landing-v3" i18nKey={feature.desc} />
            </StyledFeatureContent>
          </StyledFeature>
        ))}
      </StyledFeatureList>

      <Element name="talentEngineConsultancy" id="talentEngineConsultancy">
        <StyledStep>
          <div>
            <Heading2 editorial alignLeft>
              {t('talent-engine-landing.steps.step1.subtitle')}
            </Heading2>

            <HtmlTrans
              ns="talent-engine-landing-v3"
              i18nKey="talent-engine-landing.steps.step1.content"
            />

            <p>
              <Link to="talentEngineForm" href="#talentEngineForm">
                <ButtonLink variant="brandTalent" as="div" sizes="s">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{t('talent-engine-landing.steps.step1.cta2')}</span>
                </ButtonLink>
              </Link>
            </p>
          </div>
          <div>
            <img src={getPublicPath('/images/talentEngine/te-step1.png')} />
          </div>
        </StyledStep>
      </Element>

      <StyledCta>
        <img
          src={getPublicPath('/images/talentEngine/vitamines.png')}
          alt=""
          width="240"
        />
        <Heading3>{t('talent-engine-landing.features.cta.title')}</Heading3>
        <HtmlTrans
          ns="talent-engine-landing"
          i18nKey={t('talent-engine-landing.features.cta.desc')}
        />
        <Link to="talentEngineForm" href="#talentEngineForm">
          <ButtonLink
            variant="brandTalent"
            as="div"
            onClick={() =>
              ServiceEventTracking.trackLandingCtaClicked(
                'talent-engine-quiero-descubre'
              )
            }
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('talent-engine-landing.features.cta.cta')}</span>
          </ButtonLink>
        </Link>
      </StyledCta>
    </StyledContainer>
  );
};

export default TEFeatures;
